<template>
    <div class="p-grid">
        <Toast />
        <div class="p-col-12">
            <div class="card p-fluid">
                <h4>
                    <strong>{{ $t('Recruiters.list.Search') }}</strong>
                </h4>
                <div class="p-formgrid p-grid p-mb-3">
                    <div class="p-field p-col-12 p-md-4">
                        <label for="nameuser">{{ $t('Recruiters.list.Industry') }}</label>
                        <InputText :value="industry" id="title" type="text" :placeholder="$t('Recruiters.list.Industry')" v-model="industry" />
                        <!-- <Dropdown v-model="industry" :options="IndustryDropdown" optionLabel="name" optionValue="code"
                            :placeholder="$t('Recruiters.list.Select')" name="name" id="first_category" /> -->
                    </div>
                    <div class="p-field p-col-12 p-md-4">
                        <label for="title">{{ $t('Recruiters.list.Company Name') }}</label>
                        <InputText :value="company" id="title" type="text" :placeholder="$t('Recruiters.list.SBName')" v-model="company" />
                    </div>
                    <div class="p-field p-col-12 p-md-4">
                        <label for="title">{{ $t('Recruiters.list.Email') }}</label>
                        <InputText :value="email" id="title" type="text" :placeholder="$t('Recruiters.list.SBEmail')" v-model="email" />
                    </div>
                    <div class="p-field p-col-12 p-md-4">
                        <label for="title">{{ $t('Recruiters.list.Phone') }}</label>
                        <InputText :value="phone" id="title" type="text" :placeholder="$t('Recruiters.list.SBPhone')" v-model="phone" onkeypress="return /[0-9]/i.test(event.key)" maxlength="11" />
                    </div>
                    <div class="p-field p-col-12 p-md-4">
                        <label for="pass">{{ $t('Recruiters.list.Note') }}</label>
                        <Dropdown :value="note" id="state" v-model="note" :options="NotesDropdown" optionLabel="name" optionValue="code" :placeholder="$t('Recruiters.list.Select')"></Dropdown>
                    </div>
                </div>

                <div class="p-d-flex p-jc-between p-ai-lg-center p-ai-start p-mt-6 p-flex-column p-flex-lg-row">
                    <div class="p-mb-4 p-mb-lg-0"></div>
                    <div class="p-mb-4 p-mb-lg-0">
                        <Button :label="$t('button.search')" icon="pi pi-search" iconPos="left" class="p-button p-component p-button p-button-sm p-mr-2 p-mb-2" @click="searchRecruiter"></Button>
                        <Button :label="$t('button.reset')" icon="pi pi-replay" iconPos="left" class="p-button p-component p-button p-button-sm p-mr-2 p-mb-2" @click="resetUser"></Button>
                    </div>
                </div>
            </div>
        </div>
        <div class="p-col-12">
            <div class="card">
                <div class="p-d-flex p-jc-between p-mb-2">
                    <div>
                        <h5>{{ $t('Recruiters.list.RecruiterList') }}</h5>
                    </div>
                </div>
                <div class="p-mb-4 p-mb-lg-0 page">
                    <label for="order"
                        >{{ $t('Recruiters.list.Record') }} {{ pagination.total_records }}
                        <Dropdown class="p-ml-2" id="order" v-model="pagination.pagination_limit" :options="pagination_limit_options" optionLabel="label" optionValue="value" placeholder="10개씩 보기" />
                    </label>
                </div>
                <br />
                <DataTable :value="results" :paginator="false" class="p-datatable-gridlines" :rows="10" dataKey="id" :rowHover="true" :loading="loading1" :filters="filters1" responsiveLayout="scroll" v-model:selection="selected">
                    <!-- v-model:selection="selected" -->
                    <ConfirmDialog group="dialog" />

                    <template #empty>문의를 찾을 수 없습니다</template>
                    <template #loading>어드민 정보 로딩중..</template>

                    <!-- <column selectionMode="multiple" style="width: 16px; text-align: center" /> -->
                    <Column field="slNO" :header="$t('Recruiters.list.No')" style="min-width: 4rem">
                        <template #body="{ index }">
                            <span class="p-column-title">#</span>
                            {{ pagination.current_page * pagination.pagination_limit - pagination.pagination_limit + (index + 1) }}
                        </template>
                    </Column>
                    <Column field="name" :header="$t('Recruiters.list.Company Name')" style="min-width: 12rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Company Name</span>
                            {{ data.company_name == null ? '---' : data.company_name }}
                            <!-- {{ data.company_name }} -->
                        </template>
                    </Column>
                    <Column :header="$t('Recruiters.list.Incharge')" style="min-width: 12rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Incharge</span>
                            {{ data.in_charge == null ? '---' : data.in_charge }}
                            <!-- {{ data.in_charge }} -->
                        </template>
                    </Column>
                    <Column :header="$t('Recruiters.list.Industry')" style="min-width: 12rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Industry</span>
                            {{ data.industry_name == null ? '---' : data.industry_name }}
                            <!-- {{ data.industry }} -->
                        </template>
                    </Column>
                    <Column :header="$t('Recruiters.list.Email')" style="min-width: 12rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Email</span>
                            {{ data.email == '' ? '---' : data.email }}
                            <!-- {{ data.email }} -->
                        </template>
                    </Column>
                    <Column :header="$t('Recruiters.list.Phone')" style="min-width: 12rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Phone</span>
                            {{ data.phone_number == '' ? '---' : formatPhoneNumber(data.phone_number) }}
                            <!-- {{ data.phone_number }} -->
                        </template>
                    </Column>
                    <Column :header="$t('Recruiters.list.Address')" style="min-width: 22rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Address</span>
                            {{ data.company_address == null ? '---' : data.company_address }}
                            <!-- {{ data.company_address }} -->
                        </template>
                    </Column>
                    <Column :header="$t('Recruiters.list.Note')" style="min-width: 5rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Note</span>
                            <span v-if="data.note_status !== 1">
                                <i class="pi pi-check"></i>
                            </span>
                            <span v-else>
                                <i class="pi pi-times"></i>
                            </span>
                            <!-- {{ data.note == "" ? '---' : data.note }} -->
                            <!-- {{ data.note }} -->
                        </template>
                    </Column>
                    <Column :header="$t('Recruiters.list.Access')" style="min-width: 7rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Access</span>
                            {{ data.access_times == '' ? '---' : data.access_times }}
                            <!-- {{ data.access_times }} -->
                        </template>
                    </Column>
                    <Column :header="$t('Recruiters.list.Lastlog')" style="min-width: 12rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Lastlog</span>
                            {{ data.last_login == '' ? '---' : FormatDate(data.last_login) }}
                        </template>
                    </Column>

                    <Column :header="$t('Recruiters.list.Action')" style="min-width: 6rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Balance</span>
                            <!-- <p style="display: none">{{ data.mobile }}</p> -->
                            <div style="display: flex">
                                <router-link :to="'/MemberManagement/Recruiter/ViewRecruiter/' + data.id"
                                    ><Button label="info" class="p-button2"><i class="pi pi-eye p-mr-2"></i> </Button>
                                </router-link>
                                <!-- <router-link :to="'/Editproductcategory/' + data.id"
                                    ><Button label="info" class="p-button2" ><i class="pi pi-user-edit p-mr-2"></i> </Button>
                                </router-link>
                                <Button icon="pi pi-trash" class="p-button2" @click="confirm(data.id)" /> -->
                            </div>
                        </template>
                    </Column>
                </DataTable>
                <div class="p-paginator p-component p-paginator-bottom">
                    <button @click="paginate(1)" :class="{ 'p-disabled': pagination.current_page === 1 }" class="p-paginator-first p-paginator-element p-link" type="button" :disabled="pagination.current_page === 1">
                        <span class="p-paginator-icon pi pi-angle-double-left"></span>
                        <span class="p-ink"></span>
                    </button>
                    <button @click="paginate(pagination.current_page - 1)" :class="{ 'p-disabled': pagination.current_page === 1 }" class="p-paginator-next p-paginator-element p-link" type="button" :disabled="pagination.current_page === 1">
                        <span class="p-paginator-icon pi pi-angle-left"></span>
                        <span class="p-ink"></span>
                    </button>
                    <span class="p-paginator-pages">
                        <button
                            v-for="(page, index) in get_paginator_page(pagination.total_pages, pagination.current_page)"
                            :key="index"
                            @click="paginate(page)"
                            class="p-paginator-page p-paginator-element p-link"
                            :class="{ 'p-highlight': page === pagination.current_page }"
                            type="button"
                        >
                            {{ page }}<span class="p-ink"></span>
                        </button>
                    </span>
                    <button
                        @click="paginate(pagination.current_page + 1)"
                        :class="{ 'p-disabled': pagination.current_page === pagination.total_pages }"
                        class="p-paginator-next p-paginator-element p-link"
                        type="button"
                        :disabled="pagination.current_page === pagination.total_pages"
                    >
                        <span class="p-paginator-icon pi pi-angle-right"></span>
                        <span class="p-ink"></span>
                    </button>
                    <button
                        @click="paginate(pagination.total_pages)"
                        :class="{ 'p-disabled': pagination.current_page === pagination.total_pages }"
                        :disabled="pagination.current_page === pagination.total_pages"
                        class="p-paginator-last p-paginator-element p-link"
                        type="button"
                    >
                        <span class="p-paginator-icon pi pi-angle-double-right"></span>
                        <span class="p-ink"></span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import { useRoute } from 'vue-router';
// import validateUsersearch from '../../validations/user/validateUserSearch';
// import { FilterMatchMode, FilterOperator } from 'primevue/api';
import RecruiterService from '../../../service/API/RecruiterService';
import axios from 'axios';
import moment from 'moment';
import utils from '@/service/utils';
// import ProductService from '../service/ProductService';
// import axios from 'axios';
export default {
    data() {
        return {
            loading1: false,
            products: null,
            expandedRows: [],
            user: '',
            id: '',
            company_name: '',
            in_charge: '',
            industry: '',
            email: '',
            phone_number: '',
            company_address: '',
            company_postal_code: '',
            note: '',
            access_times: '',
            last_login: '',
            industry_name: '',
            phone: '',
            company: '',
            note_status: '',
            NotesDropdowns: '',
            NotesDropdown: [
                { name: '예', code: 'y' },
                { name: '아니요', code: 'n' },
            ],
            IndustryDropdowns: '',
            IndustryDropdown: [
                { name: '금융', code: 'Finance' },
                { name: '의료', code: 'Medical' },
                { name: '소프트웨어', code: 'Software' },
                { name: '교육', code: 'Education' },
                { name: '섬유', code: 'Textile' },
                { name: '방송', code: 'Media and news' },
                { name: '식품 가공', code: 'Food processing' },
                { name: '서비스', code: 'Hospitality' },
                { name: '건설', code: 'Construction' },
                { name: '법', code: 'Law' },
            ],
            statusdropdowns: '',
            statusdropdown: [
                { name: 'Active', code: 'active' },
                { name: 'Inactive', code: 'inactive' },
            ],
            statuses: ['unqualified', 'qualified', 'new', 'negotiation', 'renewal', 'proposal'],
            genders: [
                { name: 'Statistical', code: 'Statistical' },
                { name: 'Coupon', code: 'Coupon' },
                { name: 'Survey reminder', code: 'Survey reminder' },
                { name: 'Manual', code: 'Manual' },
            ],
            // notesDropdown: [
            //     { name: '예', code: 'Yes' },
            //     { name: '아니요', code: 'No' },
            // ],
            marital_statuss: [
                { name: 'married', code: 'married' },
                { name: 'unmarried', code: 'unmarried' },
            ],
            age_groups: [
                { name: '25~35', code: '25 ~ 35' },
                { name: '35~45', code: '35 ~ 45' },
                { name: '45~55', code: '45 ~ 55' },
                { name: '55~65', code: '55 ~ 65' },
            ],
            dropdownItem: null,
            error: {},
            start_date: '',
            end_date: '',
            notification_type: '',
            productCategoryStatus: '',
            pagination_limit_options: [
                { label: '10개씩 보기', value: 10 },
                { label: '20개씩 보기', value: 20 },
                { label: '50개씩 보기', value: 50 },
                { label: '100개씩 보기', value: 100 },
            ],
            pagination: {
                current_page: 1,
                pagination_limit: 10,
                total_pages: 0,
                total_records: 0,
            },
            totalrecords: '',
            results: [],
        };
    },
    customerService: null,
    recruiterService: null,
    created() {
        // this.storedCompanyNoteValue = localStorage.getItem('recruiter_note');
        // this.company = localStorage.getItem('recruiter_company');
        // this.email = localStorage.getItem('recruiter_email');
        // this.phone = localStorage.getItem('recruiter_phone');
        // this.note = localStorage.getItem('recruiter_note');
        // this.industry = localStorage.getItem('industry')
        this.recruiterService = new RecruiterService();
        // const data = {
        //     page: 1,
        //     limit: this.pagination.pagination_limit,
        //     company: this.company,
        //     email: this.email,
        //     industry: this.industry,
        //     phone: this.phone,
        //     note: this.note,
        // };
        // this.callAPI(data);
    },
    mounted() {
        //   this.getRecruiterList();
        this.storageData = localStorage.getItem('RecruiterManagement') ? JSON.parse(localStorage.getItem('RecruiterManagement')) : '';

        if (this.storageData != '') {
            this.RecruiterPagination = this.storageData.current_page;
            this.company = this.storageData.company == undefined ? '' : this.storageData.company;
            this.email = this.storageData.email == undefined ? '' : this.storageData.email;
            this.phone = this.storageData.phone == undefined ? '' : this.storageData.phone;
            this.industry = this.storageData.industry == undefined ? '' : this.storageData.industry;
            this.note = this.storageData.note == undefined ? '' : this.storageData.note;
        }
        if (this.RecruiterPagination == '' || this.RecruiterPagination == null) {
            if (this.company || this.email || this.industry || this.note) {
                const searchLocalParams = {
                    page: this.pagination.current_page,
                    limit: this.pagination.pagination_limit,
                    company: this.storageData.company == undefined ? '' : this.storageData.company,
                    email: this.storageData.email == undefined ? '' : this.storageData.email,
                    industry: this.storageData.industry == undefined ? '' : this.storageData.industry,
                    note: this.storageData.note == undefined ? '' : this.storageData.note,
                    phone: this.storageData.phone == undefined ? '' : this.storageData.phone,
                };
                this.getRecruiterList(searchLocalParams);
            } else {
                this.getRecruiterList({ limit: this.pagination.pagination_limit, page: this.pagination.current_page });
            }
        } else {
            const searchLocalParams = {
                page: this.RecruiterPagination,
                limit: this.pagination.pagination_limit,
                company: this.storageData.company == undefined ? '' : this.storageData.company,
                email: this.storageData.email == undefined ? '' : this.storageData.email,
                industry: this.storageData.industry == undefined ? '' : this.storageData.industry,
                note: this.storageData.note == undefined ? '' : this.storageData.note,
                phone: this.storageData.phone == undefined ? '' : this.storageData.phone,
            };
            this.getRecruiterList(searchLocalParams);
        }
    },
    watch: {
        'pagination.pagination_limit'(val) {
            this.getRecruiterList({ limit: val, page: 1 });
        },
    },
    methods: {
        // callAPI(val) {

        // },
        getRecruiterList(data) {
            // const RecruiterlistParams = {
            //     page: 1,
            //     limit: this.pagination.pagination_limit,
            // };
            this.loading1 = true;
            this.recruiterService
                .getRecruiterList(data)
                .then((res) => {
                    this.results = res.data.result;
                    this.totalrecords = res.data.total_records;
                    this.setPagination(res.data.current_page, res.data.total_pages === 0 ? 1 : res.data.total_pages, res.data.total_records);
                    this.loading1 = false;
                    console.log(res);
                })
                .catch((err) => console.log(err));
            // this.callAPI(RecruiterlistParams);
        },
        setPagination(current_page, total_pages, total_records) {
            this.pagination.current_page = current_page;
            this.pagination.total_pages = total_pages;
            this.pagination.total_records = total_records;
        },
        get_paginator_page(total, active) {
            return utils.paginate(total, active);
        },

        paginate(page) {
            this.loading1 = true;
            localStorage.setItem(
                'RecruiterManagement',
                JSON.stringify({
                    current_page: page,
                    // limit: this.pagination.pagination_limit,
                    email: this.email,
                    company: this.company,
                    phone: this.phone,
                    gender: this.gender,
                    note: this.note,
                    industry: this.industry,
                    
                })
            );
            this.recruiterService
                .getRecruiterList({
                    page: page,
                    limit: this.pagination.pagination_limit,
                    name: this.name,
                    email: this.email,
                    industry: this.industry,
                    phone: this.phone,
                    note: this.note,
                })
                .then((res) => {
                    this.results = res.data.result;
                    this.pagination.current_page = page;
                    this.loading1 = false;
                    console.log(res.data);
                })
                .catch((err) => console.log(err));
        },

        // selects() {
        //     let xyz = [];
        //     let data = this.selected;
        //     for (var a = 0; a < data.length; a++) {
        //         xyz.push(data[a].id);
        //     }
        //     this.selectedItemss = xyz.toString();
        //     if (this.calendarValue !== '') {
        //         this.calendarValue = this.calendarValue.toISOString().slice(0, 10);
        //     }
        //     if (this.calendarValue1 !== '') {
        //         this.calendarValue1 = this.calendarValue1.toISOString().slice(0, 10) + 1;
        //     }
        // },
        resetUser() {
            // localStorage.setItem('industry', '');
            // localStorage.setItem('recruiter_company', '');
            // localStorage.setItem('recruiter_email', '');
            // localStorage.setItem('recruiter_phone', '');
            // localStorage.setItem('recruiter_note', '');
            this.industry = '';
            this.note = '';
            this.company = '';
            this.phone = '';
            this.email = '';
            this.pagination.pagination_limit = '';
            localStorage.setItem('RecruiterManagement', '');
            this.getRecruiterList();
            window.location.reload();
        },
        FormatDate(value) {
            if (value) {
                return moment(String(value)).format('YYYY.MM.DD - h:mm:ss');
            }
        },
        searchRecruiter() {
            if (this.phone == '' && this.company == '' && this.industry == '' && this.email == '' && this.note == '') {
                this.$toast.add({ severity: 'error', summary: '에러 메시지', detail: '1개 이상의 검색 값을 입력하세요.', life: 3000 });
            } else {
                // localStorage.setItem('industry', this.industry);
                // localStorage.setItem('recruiter_company', this.company);
                // localStorage.setItem('recruiter_email', this.email);
                // localStorage.setItem('recruiter_phone', this.phone);
                // localStorage.setItem('recruiter_note', this.note);
                localStorage.setItem(
                    'RecruiterManagement',
                    JSON.stringify({
                        current_page: 1,
                        // limit: this.pagination.pagination_limit,
                        email: this.email,
                        company: this.company,
                        phone: this.phone,
                        gender: this.gender,
                        note: this.note,
                        industry: this.industry,
                    })
                );

                let searchParams = {
                    limit: this.pagination.pagination_limit,
                    page: 1,
                    email: this.email,
                    company: this.company,
                    phone: this.phone,
                    industry: this.industry,
                    note: this.note,
                };
                this.loading = true;
                this.recruiterService
                    .getRecruiterList(searchParams)
                    .then((res) => {
                        this.results = res.data.result;
                        this.loading1 = false;
                        this.setPagination(res.data.current_page, res.data.total_pages === 0 ? 1 : res.data.total_pages, res.data.total_records);
                    })
                    .catch(() => {
                        this.results = [];
                        this.loading1 = false;
                    });
            }
        },

        searchproduct() {
            if (this.first_category == '' && this.second_category == '' && this.third_category == '' && this.productCategoryStatus == '') {
                console.log(this.productCategoryStatus);
                this.$toast.add({ severity: 'error', summary: 'Error message', detail: '1개 이상의 검색 값을 입력하세요.', life: 3000 });
            } else {
                this.getlist();
            }
        },
        exceldownload() {
            this.productCategoryService.getExcel(this.first_category, this.second_category, this.third_category, this.productCategoryStatus?.code).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Productcategorylist.xlsx'); //or any other extension
                document.body.appendChild(link);
                link.click();
            });
        },
        today() {
            const utc = new Date().toJSON().slice(0, 10).replace(/-/g, '.');
            this.start_date = utc;
            this.end_date = utc;
            this.getlist();
            console.log(this.start_date);
        },
        lastweek() {
            const date = new Date();
            const edate = new Date();
            date.setDate(date.getDate() - 7);
            edate.setDate(edate.getDate());
            const startDate = date.getFullYear() + '.' + (date.getMonth() + 1).toString().padStart(2, '0') + '.' + date.getDate().toString().padStart(2, '0');
            const endDate = edate.getFullYear() + '.' + (edate.getMonth() + 1).toString().padStart(2, '0') + '.' + edate.getDate().toString().padStart(2, '0');
            this.start_date = startDate;
            this.end_date = endDate;
            this.getlist();
            console.log(this.start_date);
        },
        lastmonth() {
            const date = new Date();
            const edate = new Date();
            date.setDate(date.getDate() - 31);
            edate.setDate(edate.getDate());
            const startDate = date.getFullYear() + '.' + (date.getMonth() + 1).toString().padStart(2, '0') + '.' + date.getDate().toString().padStart(2, '0');
            const endDate = edate.getFullYear() + '.' + (edate.getMonth() + 1).toString().padStart(2, '0') + '.' + edate.getDate().toString().padStart(2, '0');
            this.start_date = startDate;
            this.end_date = endDate;
            this.getlist();
            console.log(this.start_date);
        },
        lastsixmonth() {
            const date = new Date();
            const edate = new Date();
            date.setDate(date.getDate() - 182);
            edate.setDate(edate.getDate());
            const startDate = date.getFullYear() + '.' + (date.getMonth() + 1).toString().padStart(2, '0') + '.' + date.getDate().toString().padStart(2, '0');
            const endDate = edate.getFullYear() + '.' + (edate.getMonth() + 1).toString().padStart(2, '0') + '.' + edate.getDate().toString().padStart(2, '0');
            this.start_date = startDate;
            this.end_date = endDate;
            this.getlist();
            console.log(this.start_date);
        },
        getParams(NotificationType) {
            localStorage.setItem('NotificationType', NotificationType);
            console.log(NotificationType);
        },
        open() {
            this.display = true;
        },
        close() {
            this.display = false;
        },
        toggle(event) {
            this.$refs.op.toggle(event);
        },

        onRowExpand(event) {
            this.$toast.add({ severity: 'info', summary: 'Product Expanded', detail: event.data.name, life: 3000 });
        },
        onRowCollapse(event) {
            this.$toast.add({ severity: 'success', summary: 'Product Collapsed', detail: event.data.name, life: 3000 });
        },
        expandAll() {
            this.expandedRows = this.products.filter((p) => p.id);
            this.$toast.add({ severity: 'success', summary: 'All Rows Expanded', life: 3000 });
        },
        collapseAll() {
            this.expandedRows = null;
            this.$toast.add({ severity: 'success', summary: 'All Rows Collapsed', life: 3000 });
        },
        formatCurrency(value) {
            return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
        },
        formatDate(value) {
            const date = new Date(value);
            var dd = date.getDate();
            var mm = date.getMonth() + 1;
            var yyyy = date.getFullYear();
            if (dd < 10) {
                dd = '0' + dd;
            }
            if (mm < 10) {
                mm = '0' + mm;
            }
            return (value = yyyy + '.' + mm + '.' + dd);
        },
        calculateCustomerTotal(name) {
            let total = 0;
            if (this.customer3) {
                for (let customer of this.customer3) {
                    if (customer.representative.name === name) {
                        total++;
                    }
                }
            }

            return total;
        },
        formatPhoneNumber(num) {
            var cleaned = ('' + num).replace(/\D/g, '');
            if (num.toString().length == '11') {
                var match = cleaned.match(/^(\d{3})(\d{4})(\d{4})$/);
                if (match) {
                    return '(' + match[1] + ') ' + match[2] + ' - ' + match[3];
                }
                return null;
            } else if (num.toString().length == '10') {
                var match1 = cleaned.match(/^(\d{2})(\d{4})(\d{4})$/);
                if (match1) {
                    return '(' + match1[1] + ') ' + match1[2] + ' - ' + match1[3];
                }
                return null;
            } else if (num.toString().length == '9') {
                var match2 = cleaned.match(/^(\d{1})(\d{4})(\d{4})$/);
                if (match2) {
                    return '(' + match2[1] + ') ' + match2[2] + ' - ' + match2[3];
                }
                return null;
            }
        },
        confirm(id) {
            var self = this;
            this.$confirm.require({
                group: 'dialog',
                header: '확인',
                message: '삭제하시겠습니까?',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: '확인',
                rejectLabel: ' 취소',
                accept: () => {
                    axios({ method: 'delete', url: `/product-category/${id}` }).then(function () {});
                    self.$toast.add({ severity: 'info', summary: '삭제', detail: '성공적으로 삭제되었습니다.', life: 3000 });
                    self.productCategoryService.getProductCategoryList(self.first_category, self.second_category, self.third_category, self.productCategoryStatus).then((data) => {
                        console.log(data);
                        this.customer1 = data;
                        this.loading1 = false;
                        this.customer1.forEach((customer) => (customer.createdDate = new Date(customer.createdDate)));
                    });
                },
                reject: () => {
                    this.$toast.add({ severity: 'error', summary: '오류가 발생했습니다', detail: '취소되었습니다', life: 3000 });
                },
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.p-datatable-tbody {
    .p-button {
        white-space: nowrap;
    }
}

.p-fluid {
    .p-button {
        width: auto;
    }
}

.p-button {
    background: white;
    // border: 1px solid #0A0A0A;
    color: #0a0a0a;
}

// button.p-button.p-component.p-button2 {
//     background: white;
//     border: 1px white;
//     --surface-hover: blue;
//     color: black;
// }
</style>
